import { render, staticRenderFns } from "./Departamentos_editar.vue?vue&type=template&id=b3ee51a8"
import script from "./Departamentos_editar.vue?vue&type=script&lang=js"
export * from "./Departamentos_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports